var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconSummary = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.602.203h28.8v3.2H.602v-3.2Zm6.4 6.4h22.4v3.2h-22.4v-3.2Z",
  fill: "#666"
})));

export default SvgIconSummary;